import RouteLeavingGuard from './RouteLeavingGuard';

export default RouteLeavingGuard;
